import React from "react";

const breadcrumbsWrapper = {
    width: "60%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gridColumnGap: "8px",
    margin: "16px 0"
}

const lightGreyDot = {
    width: "6px",
    height: "6px",
    borderRadius: "2px",
    backgroundColor: "#C3C3C3",
}

const darkGreyDot = {
    width: "6px",
    height: "6px",
    borderRadius: "2px",
    backgroundColor: "#403F42",
}

const pill = {
    backgroundColor: "#ffffff",
    borderRadius: "25px",
}

const Step1Breadcrumbs = (props) => {
    /*window.onload = () => {
        Array.from(document.getElementById('breadcrumbsWrapper').childNodes).forEach(item => {
            if (item.style.backgroundImage.includes('red')) {
                item.onmouseover = function () {
                    item.style.width = "20%";
                    item.style.cursor = "pointer";
                }
                item.onmouseout = function () {
                    item.style.width = "10%";
                    item.style.cursor = "auto";
                }
            }
            else if (item.style.backgroundImage.includes('grey')) {
                console.log('grey');
            }
        });
    }*/
    return (
        <>
            <div style={breadcrumbsWrapper} id="breadcrumbsWrapper">
                <div id="1" style={(props.subStep >= 1) ? darkGreyDot : lightGreyDot} ></div>
                <div id="2" style={(props.subStep >= 2) ? darkGreyDot : lightGreyDot} ></div>
                <div id="3" style={(props.subStep >= 3) ? darkGreyDot : lightGreyDot} ></div>
                <div id="4" style={(props.subStep >= 4) ? darkGreyDot : lightGreyDot} ></div>
                <div id="5" style={(props.subStep >= 5) ? darkGreyDot : lightGreyDot} ></div>
                <div id="6" style={(props.subStep >= 6) ? darkGreyDot : lightGreyDot} ></div>
                <div id="7" style={(props.subStep >= 7) ? darkGreyDot : lightGreyDot} ></div>
                <div id="8" style={(props.subStep >= 8) ? darkGreyDot : lightGreyDot} ></div>
                <div id="9" style={(props.subStep >= 9) ? darkGreyDot : lightGreyDot} ></div>
                <div id="10" style={(props.subStep >= 10) ? darkGreyDot : lightGreyDot} ></div>
                <div style={pill}></div>
            </div>
        </>
    )
}

export default Step1Breadcrumbs;